import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Card, Row, Col, Button, Input, Label } from 'reactstrap';
import PMCreateTicketsService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/PMCreateTicketsService';
import DisplayObject from './DisplayObject';
import CustomModal from '../../../../../../Components/Modals/CustomModal';
import { SetInnerHtmlWithClassReplacement } from "../../../../../../../Utils/Constants";
import PMSmartDataFormatter from '../PMDashboard/PMTasks/PMSubComponentsSwTeamTask/PMSmartDataFormatter';

function ProactiveMonitoringTickets(props) {
  const [selectedAlerts, setSelectedAlerts] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState('');
  const [validationModalOpen, setValidationModalOpen] = useState(false);
  const [issueDescription, setIssueDescription] = useState(false);
  const [issueDescriptionText, setIssueDescriptionText] = useState("");
  const [actionRequiredRows, setActionRequiredRows] = useState({});

  const handleActionRequiredToggle = (rowId) => {
  setActionRequiredRows(prev => ({
    ...prev,
    [rowId]: prev[rowId] === "Action Required" ? null : "Action Required"
  }));
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

const tableData =
props.activeTab === 'complete'
  ? (props.ticketsData || [])
  : (props.ticketsData || []);

// Apply search filter
const filteredData = props.ticketsData && props.ticketsData.filter(item =>
Object.values(item)
  .join(' ')
  .toLowerCase()
  .includes(searchText.toLowerCase())
);

const stripHtmlTags = (html) => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
};
const viewIssueDescription = (text) => {
  setIssueDescription(true);
  setIssueDescriptionText(text);
};
const replaceIssueDescriptionText = SetInnerHtmlWithClassReplacement(issueDescriptionText);
  const getPathwaysByPA = function (paId) {
    return (props.problemAreaPathwayList || []).filter(function (pw) {
      return String(pw.problemAreaId) === String(paId);
    });
  };

  const getSubTypesByPathway = function (pathwayId) {
    return (props.subRequestTypesList || []).filter(function (st) {
      return String(st.problemAreaPathwayId) === String(pathwayId);
    });
  };

  const formatValue = (value) => {
    if (!value || value === "N/A") return "N/A";
    try {
      const obj = JSON.parse(value);
      return `Review id: ${obj.review_id}<br/>Score: ${obj.score}<br/>Votes: ${obj.votes}`;
    } catch (err) {
      return value;
    }
  };

  const handleCreateBulkTickets = (e) => {
    e.preventDefault();
    console.log(props.ticketsData)

    const selectedIds = Array.isArray(selectedAlerts) ? selectedAlerts : [];
    const selectedData = selectedIds
      .map(id => (props.ticketsData || []).find(r => String(r.id) === String(id)))
      .filter(Boolean);

    if (selectedData.length === 0) {
      alert('No alerts selected or selected alerts not found in current data.');
      return;
    }

    // Normalize helpers
    const belongsToPA = (pathwayId, paId) => {
      if (!pathwayId || !paId) return false;
      return (props.problemAreaPathwayList || []).some(pw =>
        String(pw.id) === String(pathwayId) && String(pw.problemAreaId) === String(paId)
      );
    };
    const belongsToPathway = (subTypeId, pathwayId) => {
      if (!subTypeId || !pathwayId) return false;
      return (props.subRequestTypesList || []).some(st =>
        String(st.id) === String(subTypeId) && String(st.problemAreaPathwayId) === String(pathwayId)
      );
    };

    // Validate each selected row
    const invalid = [];
    const sanitizedSelected = selectedData.map(alert => {
      const pa = alert.problemAreaId || alert.problemArea || '';
      const pathway = alert.problemAreaPathwayId || alert.problemAreaPathwayId || '';
      const subType = alert.requestSubTypeId || alert.requestSubTypeId || '';

      const pathwayOk = belongsToPA(pathway, pa);
      const subTypeOk = belongsToPathway(subType, pathway);

      const resolved = {
        ...alert,
        problemAreaId: pa,
        problemAreaPathwayId: pathwayOk ? pathway : '',
        requestSubTypeId: subTypeOk ? subType : '',
      };

      if (!resolved.problemAreaId || !resolved.problemAreaPathwayId || !resolved.requestSubTypeId) {
        invalid.push({
          id: alert.id,
          problemAreaId: resolved.problemAreaId,
          problemAreaPathwayId: resolved.problemAreaPathwayId,
          requestSubTypeId: resolved.requestSubTypeId
        });
      }

      return resolved;
    });

    if (invalid.length > 0) {
      console.warn('Validation failed:', invalid);
      setValidationModalOpen(true);
      return;
    }

    // 1. ENABLE LOADING STATE
    setLoading(true);

    const requestData = sanitizedSelected.map(alert => ({
      id: alert.id,
      fileName:alert.fileName,
      isInternal: false,
      type: alert.type,
      mainRequestTypeId: 2,
      problemAreaId: alert.problemAreaId,
      problemAreaPathwayId: alert.problemAreaPathwayId,
      requestSubTypeId: alert.requestSubTypeId,
      asin: alert.asin,
      internalCommunication: false,
      ticketTitle: alert.type,
      integerid: alert.integerid,
      store_name: alert.store_name,
      createrPriority: 'High',
      old_value: formatValue(alert.old_value),
      new_value: formatValue(alert.new_value),
      changeType: alert.type,
      createrPriority: "Medium",
      activeTab: props.activeTab || 'all',
      // actionRequired: alert.alertActionRequired
    }));

    PMCreateTicketsService(props.token, requestData)
      .then((response) => {
        console.log('PMCreateTickets response:', response);
        // 2. REFRESH PAGE ON SUCCESS
        window.location.reload();
      })
      setLoading(false)
     
  };

  const handleSelectAlert = (row) => {
    const rowId = row.id;
    setSelectedAlerts(prev => {
      if (prev.includes(rowId)) {
        return prev.filter(id => id !== rowId);
      } else {
        return [...prev, rowId];
      }
    });
  };
  const columns = [
    ...(props.activeTab === "complete"
      ? [
          {
            Header: "Destination Id",
            accessor: "destinationid",
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p
                  title={cellInfo.value}
                  className="m-0"
                >
                  {cellInfo.value}
                </p>
              </div>
            ),
          },
        ]
      : []),

    ...(props.activeTab !== "complete"
      ? [
        {
          Header: "Select",
          accessor: "type",
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-center w-100">
              <input
                checked={selectedAlerts.includes(cellInfo.original.id)}
                disabled={cellInfo.original.status === "Created"}
                onClick={() => handleSelectAlert(cellInfo.original)}
                type='checkbox'
              />
            </div>
          ),
          width: 65,
        },
      ]
      : []),
    {
      Header: "Store Name",
      accessor: "store_name",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center ml-1 w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
  
    {
      Header: "Asin",
      accessor: "asin",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    ...(props.activeTab !== "complete"
      ? [
          {
            Header: "Type",
            accessor: "type",
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p
                  title={cellInfo.value}
                  className="m-0 comment-paragraph-Amazon-Alert-table"
                >
                  {cellInfo.value}
                </p>
              </div>
            ),
          },
        ]
      : []),
    ...(props.activeTab !== "complete"
      ? [
          {
            Header: "Old Value",
            accessor: "old_value",
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p
                  title={cellInfo.value}
                  className="m-0 comment-paragraph-Amazon-Alert-table"
                >
                  <DisplayObject data={cellInfo.value} />
                </p>
              </div>
            ),
          },
          {
            Header: "New Value",
            accessor: "new_value",
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p
                  title={cellInfo.value}
                  className="m-0 comment-paragraph-Amazon-Alert-table"
                >
                  <DisplayObject data={cellInfo.value} />
                </p>
              </div>
            ),
          },
        ]
      : [
          {
            Header: "Issue Description",
            accessor: "ticket_issueDescription",
            Cell: (cellInfo) => (
                <div className="d-flex justify-content-center w-100">
          <p
            className="m-0 comment-paragraph"
            style={{ color: "#3D85C6", cursor: "pointer" }}
            onClick={() =>
              viewIssueDescription(
                cellInfo.value,
                cellInfo.original.issueDescription
              )
            }
          >
            <b>{stripHtmlTags(cellInfo.value)}</b>
          </p>
        </div>
            ),
          },
        ]),
    {
      Header: "Status",
      accessor: "status",
      width: 70,
    },
    {
      Header: "Priority",
      accessor: "priority",
      // width:100,
      Cell: ({ value }) => (
        <div className='d-flex justify-content-center w-100'>
          {value}
        </div>
      )
    },
    {
      Header: "Problem Area",
      accessor: "problemAreaId",
      Cell: (cellInfo) => {
        // Extract 'original' from cellInfo to access the status
        const { value, index, original } = cellInfo; 
        const selectedPA = (props.problemAreaList || []).find((pa) => String(pa.id) === String(value));
        
        if (props.activeTab === "complete" || original.status === "Created") {
          return (
            <div className="text-center">
              {/* This displays the text value you sent from the backend */}
              <p className="m-0">{original.problemArea || "N/A"}</p>
            </div>
          );
        }
        return (
          // {props.ticketsData && props.ticketsData.status=='Created'}
          <Input
            type="select"
            value={value || ""}
            onChange={(e) => props.handleTableFieldChange(cellInfo.original.id, "problemAreaId", e.target.value)}
            bsSize="sm"
            // DISABLE IF STATUS IS CREATED
            // disabled={original.status === "Created"} 
          >
            <option value="">Select Problem Area</option>
            {(props.problemAreaList || []).map((pa) => (
              <option key={pa.id} value={pa.id}>{pa.problemArea}</option>
            ))}
          </Input>
        );
      },
    },
    {
      Header: "Problem Pathway",
      accessor: "problemAreaPathwayId",
      Cell: (cellInfo) => {
        const { original, value, index } = cellInfo;
        const pathwayOptions = original.problemAreaId ? getPathwaysByPA(original.problemAreaId) : [];
        const selectedPathway = pathwayOptions.find((pw) => String(pw.id) === String(value));
        
        if (props.activeTab === "complete" || original.status === "Created") {
          return (
            <div className="text-center">
              <p className="m-0">{original.problemAreaPathway || "N/A"}</p>
            </div>
          );
        }

        return (
          <Input
            type="select"
            value={value || ""}
            onChange={(e) => props.handleTableFieldChange(cellInfo.original.id, "problemAreaPathwayId", e.target.value)}
            bsSize="sm"
            // DISABLE IF NO PA SELECTED OR STATUS IS CREATED
            disabled={!original.problemAreaId || original.status === "Created"}
          >
            <option value="">Select Problem Pathway</option>
            {pathwayOptions.map((pw) => (
              <option key={pw.id} value={pw.id}>{pw.problemAreaPathway}</option>
            ))}
          </Input>
        );
      },
    },
    {
      Header: "Problem Type",
      accessor: "requestSubTypeId",
      Cell: (cellInfo) => {
        const { original, value, index } = cellInfo;
        const subTypeOptions = original.problemAreaPathwayId ? getSubTypesByPathway(original.problemAreaPathwayId) : [];
        const selectedSubType = subTypeOptions.find((st) => String(st.id) === String(value));
        
        if (props.activeTab === "complete" || original.status === "Created") {
          return (
            <div className="text-center">
              <p className="m-0">{original.requestSubTypes || "N/A"}</p>
            </div>
          );
        }

        return (
          <Input
            type="select"
            value={value || ""}
            onChange={(e) => props.handleTableFieldChange(cellInfo.original.id, "requestSubTypeId", e.target.value)}
            bsSize="sm"
            // DISABLE IF NO PATHWAY SELECTED OR STATUS IS CREATED
            disabled={!original.problemAreaPathwayId || original.status === "Created"}
          >
            <option value="">Select Problem Type</option>
            {subTypeOptions.map((st) => (
              <option key={st.id} value={st.id}>{st.requestSubTypes}</option>
            ))}
          </Input>
        );
      },
    },
    {
      Header: "Created At",
      accessor: "created_at",
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center">
          <p title={cellInfo.value} className="m-0 comment-paragraph-Amazon-Alert-table">{cellInfo.value}</p>
        </div>
      ),
    },
    {
      Header: "Action Required",
      accessor: "alertActionRequired",
      width: 150,
      Cell: (cellInfo) => {
        const rowId = cellInfo.original.id;
        console.log(rowId)
        const currentValue = actionRequiredRows[rowId] !== undefined
          ? actionRequiredRows[rowId]
          : cellInfo.original.alertActionRequired;
    
        const isChecked = currentValue === "Action Required";
        const isDisabled = cellInfo.original.status === "Created" || props.activeTab === "complete";
    
        return (
          <div className="d-flex justify-content-center w-100">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleActionRequiredToggle(rowId)}
              disabled={isDisabled}
              style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            />
          </div>
        );
      }
    },
  ];

  return (
    <>
      <Col md={12} className="mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="m-0">
            <b>TICKETS</b>
          </h5>
          <div className="d-flex justify-content-end">
            <Input
              type="text"
              placeholder="Search Tickets..."
              value={searchText}
              onChange={handleSearchChange}
              className={`${props.activeTab === "complete" ? "w-100" : "w-100 mr-4"}`}
            />
            {props.activeTab !== "complete" && (
              <Button
                onClick={handleCreateBulkTickets}
                disabled={selectedAlerts.length === 0 || loading}
                className="btn-background-color-Proceed-gallery w-75 hidden-btn"
              >
                {loading
                  ? `Creating ${selectedAlerts.length} Tickets...`
                  : `Create Ticket (${selectedAlerts.length})`}
              </Button>
            )}
          </div>
        </div>
      </Col>
      <Col md={12}>
        <ReactTable
          data={filteredData}
          columns={columns}
          className="-fixed -highlight -striped mt-2"
          getTheadProps={() => ({
            style: { overflowY: "hidden", background: "#B1FA63", color: "#243837" },
          })}
          defaultPageSize={5}
          noDataText={"No Data Found."}
        />
      </Col>

      {/* CUSTOM MODAL FOR VALIDATION ALERT */}
        <CustomModal
          isOpen={validationModalOpen}
          toggle={() => { setValidationModalOpen(!validationModalOpen) }}
          size={"md"}
          header={'Missing Information'}
          className="curve-popup"
        >
          <Card className="curve-popup p-3">
            <Row>
              <Col md={12}>
                <div className="text-left">
                  {/* Header Section inside Card */}
                  <h5><b>Action Required:</b></h5>
                  
                  {/* Message Body */}
                  <h6>
                    Please select <b>Problem Area</b>, <b>Problem Pathway</b>, and <b>Problem Type</b> for all selected Notifications before creating tickets.
                  </h6>
                  </div>
              </Col>

              {/* Footer: Action Buttons */}
              <Col md={12} className='d-flex justify-content-end mt-2'>
                <Button
                  className="btn-background-color-Proceed-gallery mr-3"
                  onClick={() => setValidationModalOpen(false)}
                >
                  OK
                </Button>
              </Col>
            </Row>
          </Card>
        </CustomModal>
        <CustomModal
        header={"Issue Description"}
        isOpen={issueDescription}
        toggle={() => setIssueDescription(!issueDescription)}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button
              color={"link"}
              onClick={() => setIssueDescription(!issueDescription)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <Label>
          <p className="issue-discription-set">
          <PMSmartDataFormatter 
                    data={replaceIssueDescriptionText} 
                    maxLength={200} 
                  />
                  </p>
         
          {/* <p>{issueDescriptionText}</p> */}
        </Label>
      </CustomModal>
    </>
  )
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
});

export default connect(mapStateToProps)(ProactiveMonitoringTickets);